import React from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooterAction,
  ModalOverlay
} from '@apex/component-library'
import { Stack, Box, Text, Flex } from '@chakra-ui/react'
import { ModalBasicDetails } from './ModalBasicDetails'
import { ModalDescriptionDetails } from './ModalDescriptionDetails'
import { ModalSecurityDetails } from './ModalSecurityDetails'
import { PositionJournalValues } from 'src/containers/PositionJournals/types'
import { useFormikContext } from 'formik'
export interface PositionJournalPreviewModalProps {
  fromAccountDisplayText: string
  toAccountDisplayText: string
  onClose: () => void
  isOpen: boolean
  hasSubmitPermission: boolean
}

export const PositionJournalPreviewModal = ({
  fromAccountDisplayText,
  toAccountDisplayText,
  onClose,
  isOpen,
  hasSubmitPermission
}: PositionJournalPreviewModalProps) => {
  const formik = useFormikContext<PositionJournalValues>()

  return (
    <Modal isCentered motionPreset='slideInBottom' isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent width='100%' maxW='600px' data-testid='positionJournalModal'>
        <ModalHeader className='test-id-header-1'>
          <Text as='h4'>Position Journal Transfer</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody mb={6}>
          <Stack spacing={6}>
            <Text>Please review the details of your transfer below.</Text>
            <Box>
              <ModalBasicDetails
                journalType={formik.values.journalType}
                sourceAccount={fromAccountDisplayText}
                destinationAccount={toAccountDisplayText}
              />
            </Box>
            <Box>
              <ModalSecurityDetails
                securityCodeType={formik.values.securityCodeType}
                securityId={formik.values.securityId}
                amount={formik.values.amount}
                quantity={formik.values.quantity}
              />
            </Box>
            {(formik.values.sourceAccountDescription ||
              formik.values.sourceAccountDescription2 ||
              formik.values.destinationAccountDescription ||
              formik.values.destinationAccountDescription2) && (
              <Box>
                <ModalDescriptionDetails
                  sourceAccountDescription={formik.values.sourceAccountDescription}
                  sourceAccountDescription2={formik.values.sourceAccountDescription2}
                  destinationAccountDescription={formik.values.destinationAccountDescription}
                  destinationAccountDescription2={formik.values.destinationAccountDescription2}
                />
              </Box>
            )}
          </Stack>
        </ModalBody>
        <ModalFooterAction>
          <Flex>
            <Box ml='auto'>
              <Button variant='white' className='test-id-cancel-btn' onClick={onClose} marginRight='2'>
                Cancel
              </Button>
              <Button
                isLoading={formik.isSubmitting}
                isDisabled={!hasSubmitPermission || formik.isSubmitting}
                variant='primary'
                className='test-id-confirm-btn'
                onClick={formik.submitForm}
              >
                Confirm
              </Button>
            </Box>
          </Flex>
        </ModalFooterAction>
      </ModalContent>
    </Modal>
  )
}
